import script from "./AdminTokenLabelOrderView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminTokenLabelOrderView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminTokenLabelOrderView.vue?vue&type=style&index=0&id=7dd662bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd662bf"]])

export default __exports__